import React from 'react';
import {
  deleteDesignation,
  getDesignations,
  postDesignations,
} from '../../../Services/MasterdataService';
import {
  DESIGNATIONS,
  SHOW_NOTIFICATION,
  DESIGNATION_NAME,
} from '../../../../constants';
import { useDispatch } from 'react-redux';
import CommonComponent from './CommonComponent';

const Desginations = () => {
  const [loader, setLoader] = React.useState(false);
  const [loadingApiCall, setLoadingApiCall] = React.useState(false);
  const [title, setTitle] = React.useState('');
  const [isError, setIsError] = React.useState(false);
  const [tempInputList, setTemp] = React.useState([]);
  const [backToDefault, setDefault] = React.useState(true);
  const dispatch = useDispatch();
  const item = { name: DESIGNATIONS, property: DESIGNATION_NAME };
  const [titlesList, setTitlesList] = React.useState([]);
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const loadData = async () => {
    const response = await getDesignations();
    setLoader(true);
    if (response.isError === false) {
      setTitlesList(response.data.data);
      setLoader(false);
    } else {
      setLoader(false);
    }
    if (response.status !== 200) {
      dipatchNotification(response.type, response.message);
    }
  };
  const onAddClick = async () => {
    if (title.trim() === '' && tempInputList.length === 0) {
      setIsError(true);
      return;
    }
    const inputList = [...tempInputList, title].filter((ele) => ele !== '');
    setLoadingApiCall(true);
    const response = await postDesignations(inputList);
    setLoadingApiCall(false);
    if (response.isError === false) {
      setTitlesList([...titlesList, ...response.data.data]);
      setTemp([]);
      setTitle('');
      setDefault(!backToDefault);
    }
    dipatchNotification(response.type, response.message);
  };
  const handleDelete = async (deletedItem) => {
    const response = await deleteDesignation(deletedItem.id);
    if (response.isError === false) {
      const updatedList = titlesList.filter(
        (item) => item.id !== deletedItem.id,
      );
      setTitlesList(updatedList);
    }
    dipatchNotification(response.type, response.message);
  };
  return (
    <CommonComponent
      item={item}
      loadData={loadData}
      loader={loader}
      setTitle={setTitle}
      setTemp={setTemp}
      titlesList={titlesList}
      isError={isError}
      setIsError={setIsError}
      onAddClick={onAddClick}
      handleDelete={handleDelete}
      backToDefault={backToDefault}
      loadingApiCall={loadingApiCall}
    />
  );
};

export default Desginations;
